import { Body1, Caption } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FileMessageInfo.css';

type TFileMessageInfoProps = {
  name: string;
  size?: string;
  src: string | null;
  isOutcoming: boolean;
};

export const FileMessageInfo: React.FC<TFileMessageInfoProps> = ({ name, size, src, isOutcoming }) => {
  const textColor = isOutcoming ? 'text-inverted-default' : 'text-main-default';

  const fileName = (
    <Body1 color={textColor} wordWrap="break-word">
      {name}
    </Body1>
  );

  return (
    <div className={styles['info']}>
      <span className={styles['name']} data-testid="FileMessageInfoName">
        {src ? (
          <a href={src} download target="_blank" rel="noreferrer" className={styles['link']}>
            {fileName}
          </a>
        ) : (
          fileName
        )}
      </span>
      <Caption color={textColor} data-testid="FileMessageInfoSize">
        <span className={styles['size']}>Файл{size && ` • ${size}`}</span>
      </Caption>
    </div>
  );
};
